/**
 * @generated SignedSource<<eeafa8b3ed837a9dcdc36b5f4c4061a8>>
 * @relayHash 1d71748cea601e3317db4e6052ccf025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c1a24b370bb229e795c1d51608b80322d05729060d09096d500f660625a9fae5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoard_JiraBoardQuery } from './JiraBoard_JiraBoardQuery.graphql';

import isAssignAgentsInlineM2TechnicalEnabled_provider from '@jira/board__relay-providers/src/AssignAgentsInlineM2TechnicalRelayprovider';
import isAutoManagedSprintsEnabled_provider from '@jira/board__relay-providers/src/AutoManagedSprintsForHarmonisedBoard';
import withBoardM3_provider from '@jira/board__relay-providers/src/BoardHarmonisationMilestone3';
import boardInlineAssignAgent_provider from '@jira/board__relay-providers/src/BoardInlineAssignAgent';
import jisDevSummaryField_provider from '@jira/board__relay-providers/src/BoardJISDevSummaryField';
import includeGups_provider from '@jira/board__relay-providers/src/JfindMatureExampleProject';
import withSwimlanesChangeboarding_provider from '@jira/board__relay-providers/src/SwimlanesChangeboarding';
import withTmpHarmonisationOnboarding_provider from '@jira/board__relay-providers/src/TmpHarmonisationOnboarding';

const node: PreloadableConcreteRequest<JiraBoard_JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c1a24b370bb229e795c1d51608b80322d05729060d09096d500f660625a9fae5",
    "metadata": {},
    "name": "JiraBoard_JiraBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraboard__relayproviderssrcJfindMatureExampleProjecttsx": includeGups_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcSwimlanesChangeboardingtsx": withSwimlanesChangeboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcTmpHarmonisationOnboardingtsx": withTmpHarmonisationOnboarding_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardHarmonisationMilestone3tsx": withBoardM3_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAutoManagedSprintsForHarmonisedBoardtsx": isAutoManagedSprintsEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcAssignAgentsInlineM2TechnicalRelayprovidertsx": isAssignAgentsInlineM2TechnicalEnabled_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardJISDevSummaryFieldtsx": jisDevSummaryField_provider,
      "__relay_internal__pv__jiraboard__relayproviderssrcBoardInlineAssignAgenttsx": boardInlineAssignAgent_provider
    }
  }
};

export default node;
